import ReviewPlaceholder from '@/assets/icons/reviewPlaceholder.svg?react';
import EnrichedAmount from '@/assets/icons/enrichedAmt19.svg?react';
import { components } from '@/types/api';
import EnrichedBlock from './EnrichedBlock';
import { toFixedTwo } from '@/lib/utils';
import useOpenApiClient from '@/hooks/useOpenApiClient';

export default function ReceiptSummary({
  receipt,
}: {
  receipt: components['schemas']['ReceiptOutput'];
}) {
  const { userRole } = useOpenApiClient();
  return (
    <>
      {receipt.status === 'review_requested' ||
      receipt.status === 'in_review' ||
      receipt.status === 'processing' ? (
        <div className="mx-15 mb-4 flex flex-col items-center justify-center">
          <ReviewPlaceholder />
          <span className="text-center">
            {userRole === 'live' ? 'Receipt' : 'Enriched'} summary will show here once this receipt
            is out of review.
          </span>
        </div>
      ) : (
        <>
          <div className="px-4">
            <div className="space-y-2">
              <p className="pt-2 text-xl font-bold">
                {+receipt.total_benefit === 0
                  ? receipt.transaction_amount && (
                      <>You paid ${toFixedTwo(receipt.transaction_amount)} for this transaction</>
                    )
                  : receipt.transaction_amount && (
                      <>
                        <span className="text-primary">${toFixedTwo(receipt.total_benefit)}</span>
                        <span className="m-1 inline-flex">
                          <EnrichedAmount />
                        </span>
                        has been enriched and is back in your pocket!
                      </>
                    )}
              </p>
              <span className="text-xs font-normal">
                {+receipt.total_benefit === 0 ? (
                  <>{userRole !== 'live' && "We didn't find any items eligible for enrichment"}</>
                ) : (
                  <>We’ve used dollars from these accounts to cover some items:</>
                )}
              </span>
            </div>
          </div>
          {receipt.benefit_totals && Object.keys(receipt.benefit_totals).length ? (
            <EnrichedBlock benefitTotals={receipt.benefit_totals} />
          ) : null}
        </>
      )}
    </>
  );
}
